import { render, staticRenderFns } from "./ShippingInsurancesTable.vue?vue&type=template&id=62f7b09f&scoped=true"
import script from "./ShippingInsurancesTable.vue?vue&type=script&lang=js"
export * from "./ShippingInsurancesTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingInsurancesTable.vue?vue&type=style&index=0&id=62f7b09f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7b09f",
  null
  
)

export default component.exports